import React, {
  FunctionComponent,
} from 'react';
import { Flex } from 'rebass/styled-components';
import {
  DeveloperKeysV1, DeveloperKeysV2, Loading,
} from '../components';
import { useAppState } from '../hooks';

const Settings: FunctionComponent<{}> = () => {
  const { isCcsV2, isLoading } = useAppState();

  if (isLoading) {
    return (
      <Flex sx={{ width: '100%', height: '100%' }} flexDirection="column" alignItems="center" justifyContent="center">
        <Loading size={24} />
      </Flex>
    );
  }

  return isCcsV2 ? (
    <DeveloperKeysV2 />
  ) : (
    <DeveloperKeysV1 />
  );
};

export default Settings;
